module.exports = __webpack_public_path__ + "static/media/bookmark-ico.18d10d1f.svg";